"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateTopiaFinancialProjection = void 0;
var date_fns_1 = require("date-fns");
var helpers_1 = require("./helpers");
function calculateTopiaFinancialProjection(input) {
    var accountStates = {};
    var startDate = input.modelStartDate || new Date();
    var inflation = input.inflation || 0.03;
    // Initialize account states
    for (var i = 0; i < input.user.accounts.length; i++) {
        accountStates[input.user.accounts[i].id] = {
            account: input.user.accounts[i],
            balance: input.user.accounts[i].balance,
            coastBalance: input.user.accounts[i].balance,
            projection: [input.user.accounts[i].balance],
        };
    }
    // for (let account of input.accounts) {
    //   accountStates[account.id] = {
    //     account,
    //     balance: account.amount,
    //     coastBalance: account.amount,
    //     projection: [account.amount],
    //   };
    // }
    accountStates["surplus"] = {
        account: {
            provider: "manual",
            name: "Surplus",
            annual_return: 0.07,
            balance: 0,
            type: "SAVINGS",
            sub_type: "OTHER",
            id: "surplus",
            monthly_projected_contribution: {
                presentValue: 0,
            },
            user_id: "",
        },
        balance: 0,
        coastBalance: 0,
        projection: [0],
    };
    var currentNw = input.user.accounts
        // .filter((acc) => !acc.disabled)
        .reduce(function (prev, acc) { return prev + (acc.type === "DEBT" ? -1 : 1) * acc.balance; }, 0);
    var projectionState = {
        networthNoInflation: [currentNw],
        coastNetworth: [currentNw],
        networth: [currentNw],
    };
    // TODO: Figure out safe withdrawal rate
    var baristaIncome = input.baristaIncome || 1000;
    var leanFIReductionPercentage = input.leanFIPercentageReduction || 0.3;
    var fatFIIncreasePercentage = input.fatFIPercentageIncrease || 0.3;
    var spendAtFi = (0, helpers_1.getPVSum)(input.user.expenses.map(function (exp) { return exp.amount; }), "at-fi");
    var fiNumber = spendAtFi * 12 * 25;
    // If barista income is larger than spend at fi then they have reached barista FI. Barista FI # is 0
    var baristaFiNumber = spendAtFi - baristaIncome > 0 ? (spendAtFi - baristaIncome) * 12 * 25 : 0;
    var leanFINumber = spendAtFi * (1 - leanFIReductionPercentage) * 12 * 25;
    var fatFINumber = spendAtFi * (1 + fatFIIncreasePercentage) * 12 * 25;
    var dob = input.user.date_of_birth;
    var baristaFiDate;
    var fiDate;
    var coastFiDate;
    var underEFDate;
    var leanFIDate;
    var fatFIDate;
    var startingExpenses = (0, helpers_1.getPVSum)(input.user.expenses.map(function (exp) { return exp.amount; }));
    var emergencyFundTarget = (input.emergencyFundMonths || 3) * startingExpenses;
    var startingNetworthAboveEF = currentNw >= emergencyFundTarget;
    var totalInvestmentPortfolio = input.user.accounts
        .filter(function (acc) { return acc.type !== "DEBT"; } // && !acc.disabled
    // (acc) => acc.type !== "Debt" && !acc.disabled && acc.type !== "Cash"
    )
        .reduce(function (prev, acc) { return prev + acc.balance; }, 0);
    var annualSwrIncome = totalInvestmentPortfolio * 0.04;
    var monthlySwrIncome = annualSwrIncome / 12;
    // let totalPassiveIncome = input.incomes
    //   .filter((inc) => !inc.disabled && inc.type !== "Salary")
    //   .reduce((prev, inc) => prev + getPVValue(inc.amount), 0);
    // const pctCashflowFi = totalPassiveIncome / startingExpenses;
    var incomePVs = input.user.incomes.map(function (inc) {
        if (input.tinker) {
            var tinkerIncome = input.tinker.income[inc.id];
            if (tinkerIncome) {
                return tinkerIncome.projectedValue;
            }
            else {
                return inc.value;
            }
        }
        else {
            return inc.value;
        }
    });
    var actualIncome = (0, helpers_1.calculateNetIncome)(input.user, input.user.incomes);
    var pvIncome = [{ presentValue: actualIncome }];
    var startingIncome = (0, helpers_1.getPVSum)(pvIncome);
    var _loop_1 = function (month) {
        var d = (0, date_fns_1.startOfMonth)((0, date_fns_1.add)(startDate, { months: month }));
        var nw = 0;
        var coastNw = 0;
        // Figure out this months income
        // let income = getPVSum(incomePVs, d);
        // Showing actual income rather than total gross
        var income = actualIncome;
        var expenses = (0, helpers_1.getPVSum)(input.user.expenses.map(function (exp) { return exp.amount; }), d);
        var savings = income - expenses;
        var remainingCash = savings;
        var spendMoney = function (amount) {
            remainingCash -= amount;
            return amount;
        };
        for (var _i = 0, _a = Object.keys(accountStates); _i < _a.length; _i++) {
            var accountId = _a[_i];
            if (accountId === "surplus")
                continue;
            var state = accountStates[accountId];
            //   Projected growth
            if (state.account.annual_return) {
                // Formula for compounding interest:
                // p * (Math.pow((1 + (r / n)), (n * t)));
                state.balance =
                    state.balance * Math.pow(1 + state.account.annual_return, 1 / 12);
                state.coastBalance =
                    state.coastBalance *
                        Math.pow(1 + state.account.annual_return, 1 / 12);
            }
            //   Contributions and debt payments
            if (state.account.type === "DEBT" || state.account.type === "ASSET") {
                if (state.balance > 0 && state.account.monthly_projected_contribution) {
                    var payment = Math.min(state.balance, (0, helpers_1.getPVValue)(state.account.monthly_projected_contribution, d));
                    state.balance -= spendMoney(payment);
                    state.coastBalance -= payment;
                }
            }
            else if (state.account.monthly_projected_contribution) {
                var topup = (0, helpers_1.getPVValue)(state.account.monthly_projected_contribution);
                var employer_contribution = state.account
                    .monthly_third_party_contribution
                    ? state.account.monthly_third_party_contribution.presentValue
                    : 0;
                state.balance += spendMoney(topup) + employer_contribution;
                state.coastBalance += topup;
            }
            // else if (savings > 0) {
            //   state.balance += spendMoney(
            //     Math.min(savings, state.account.monthlyTopup)
            //   );
            // }
            if (state.account.type === "DEBT" &&
                !state.account.is_paid_off_each_month) {
                nw -= state.balance;
                coastNw -= state.coastBalance;
            }
            else {
                nw += state.balance;
                coastNw += state.coastBalance;
            }
            state.projection.push(state.balance);
        }
        // Handle surplus and defecit
        var surplusAccount = accountStates["surplus"];
        if (surplusAccount.balance > 0) {
            surplusAccount.balance =
                surplusAccount.balance *
                    Math.pow(1 + surplusAccount.account.annual_return, 1 / 12);
        }
        surplusAccount.balance += remainingCash;
        surplusAccount.projection.push(surplusAccount.balance);
        nw += surplusAccount.balance;
        // Calculate the inflation value
        var nwWithInflation = nw / Math.pow(1 + inflation, month / 12);
        var coastNwWithInflation = coastNw / Math.pow(1 + inflation, month / 12);
        projectionState.networthNoInflation.push(nw);
        projectionState.coastNetworth.push(coastNwWithInflation);
        projectionState.networth.push(nwWithInflation);
        if (startingNetworthAboveEF &&
            nwWithInflation < emergencyFundTarget &&
            !underEFDate) {
            underEFDate = month;
        }
        if (nwWithInflation >= fiNumber && !fiDate) {
            fiDate = month;
        }
        if (nwWithInflation >= baristaFiNumber && !baristaFiDate) {
            baristaFiDate = month;
        }
        if (coastNwWithInflation >= fiNumber && !coastFiDate) {
            coastFiDate = month;
        }
        if (nwWithInflation >= leanFINumber && !leanFIDate) {
            leanFIDate = month;
        }
        if (nwWithInflation >= fatFINumber && !fatFIDate) {
            fatFIDate = month;
        }
    };
    // Calculate account balances for each month for 100 years
    for (var month = 1; month <= 100 * 12; month++) {
        _loop_1(month);
    }
    //   Calculate outputs
    var fiAge;
    var baristaFiAge;
    var coastFiAge;
    var leanFIAge;
    var fatFIAge;
    if (fiDate) {
        fiAge = (0, date_fns_1.intervalToDuration)({
            start: dob,
            end: (0, date_fns_1.add)(startDate, { months: fiDate }),
        }).years;
    }
    if (baristaFiDate) {
        baristaFiAge = (0, date_fns_1.intervalToDuration)({
            start: dob,
            end: (0, date_fns_1.add)(startDate, { months: baristaFiDate }),
        }).years;
    }
    if (coastFiDate) {
        coastFiAge = (0, date_fns_1.intervalToDuration)({
            start: dob,
            end: (0, date_fns_1.add)(startDate, { months: coastFiDate }),
        }).years;
    }
    if (leanFIDate) {
        leanFIAge = (0, date_fns_1.intervalToDuration)({
            start: dob,
            end: (0, date_fns_1.add)(startDate, { months: leanFIDate }),
        }).years;
    }
    if (fatFIDate) {
        fatFIAge = (0, date_fns_1.intervalToDuration)({
            start: dob,
            end: (0, date_fns_1.add)(startDate, { months: fatFIDate }),
        }).years;
    }
    var year5Nw = projectionState.networth[60];
    var year5NwNoInflation = projectionState.networthNoInflation[60];
    var year25Nw = projectionState.networth[12 * 25];
    var year25NwNoInflation = projectionState.networthNoInflation[12 * 25];
    // console.log(actualIncome);
    return {
        accounts: accountStates,
        projection: projectionState,
        output: {
            currentNw: currentNw,
            fiDate: fiDate ? (0, date_fns_1.add)(startDate, { months: fiDate }) : undefined,
            fiNumber: fiNumber,
            //   year5Nw,
            //   year5NwNoInflation,
            //   year25Nw,
            //   year25NwNoInflation,
            fiAge: fiAge,
            spendAtFi: spendAtFi,
            baristaIncome: baristaIncome,
            willReachFi: !!fiDate,
            leanFINumber: leanFINumber,
            leanFIDate: leanFIDate
                ? (0, date_fns_1.add)(startDate, { months: leanFIDate })
                : undefined,
            leanFIAge: leanFIAge,
            fatFINumber: fatFINumber,
            fatFIDate: fatFIDate ? (0, date_fns_1.add)(startDate, { months: fatFIDate }) : undefined,
            fatFIAge: fatFIAge,
            baristaFiNumber: baristaFiNumber,
            baristaFiAge: baristaFiAge,
            baristaFiDate: baristaFiDate
                ? (0, date_fns_1.add)(startDate, { months: baristaFiDate })
                : undefined,
            willReachBaristaFi: !!baristaFiDate,
            coastFiDate: coastFiDate
                ? (0, date_fns_1.add)(startDate, { months: coastFiDate })
                : undefined,
            coastFiAge: coastFiAge,
            willReachCoastFi: !!coastFiDate,
            emergencyFundTarget: emergencyFundTarget,
            startingNetworthAboveEF: startingNetworthAboveEF,
            underEFDate: underEFDate
                ? (0, date_fns_1.add)(startDate, { months: underEFDate })
                : undefined,
            // totalIncome: startingIncome,
            totalIncome: actualIncome,
            test: "Chad is here and it is updating",
            totalInvestmentPortfolio: totalInvestmentPortfolio,
            annualSwrIncome: annualSwrIncome,
            monthlySwrIncome: monthlySwrIncome,
            // totalPassiveIncome,
            // pctCashflowFi,
            startingMonthlyExpenses: startingExpenses,
        },
    };
}
exports.calculateTopiaFinancialProjection = calculateTopiaFinancialProjection;
